<em-main>
  <div class="layout--row">
    <h3 class="layout--third-width" i18n>Documentation</h3>

    <div class="layout--full-width layout--column layout--gap-larger">
      <em-documentation-table></em-documentation-table>
      <em-faq></em-faq>
    </div>
  </div>
</em-main>
